// src/components/MainMenu.jsx
import { useState } from 'react'; // 1. Importe o useState
import { useNavigate } from 'react-router-dom';
import { Popover, PopoverContent, PopoverTrigger } from '@radix-ui/react-popover';
import { Menu, Home, Users, KeyRound, Package, BarChart3, ContactRound, ShieldBan, MessageCircle, Smartphone } from 'lucide-react';
import { logger } from '@/lib/logger/index';
import { FEATURES } from '@/lib/config';
import { useAccountStatus } from '@/hooks/useAccountStatus';

// Itens do menu para facilitar a manutenção
const BASE_MENU_ITEMS = [
  { label: 'Início', path: '/', icon: Home },
  { label: 'Condôminos', path: '/condominos', icon: Users },
  { label: 'Sync Google Contacts', path: '/sync-contatos', icon: ContactRound },
  { label: 'Autorização', path: '/autorizacao-acesso', icon: KeyRound },
  { label: 'Encomendas', path: '/encomendas', icon: Package },
  { label: 'Dashboard', path: '/dashboard', icon: BarChart3 },
];

const BLACKLIST_ITEM = { label: 'Blacklist', path: '/blacklist', icon: ShieldBan };

// Exibido só para administradores, com a flag ativa
const CONCILIACAO_ITEM = { label: 'Conciliação WhatsApp', path: '/admin/conciliacao-whatsapp', icon: MessageCircle };
// Exibido só para administradores: conectar o número de WhatsApp do condomínio
const WHATSAPP_ITEM = { label: 'WhatsApp do condomínio', path: '/admin/whatsapp', icon: Smartphone };

export function MainMenu() {
  const navigate = useNavigate();
  const { isAdmin } = useAccountStatus();
  // FEATURES é lido na renderização: as flags do condomínio chegam depois do carregamento dos módulos.
  const itens = [
    ...BASE_MENU_ITEMS,
    ...(FEATURES.BLACKLIST ? [BLACKLIST_ITEM] : []),
    ...(isAdmin ? [WHATSAPP_ITEM] : []),
    ...(isAdmin && FEATURES.WHATSAPP_CONCILIACAO ? [CONCILIACAO_ITEM] : []),
  ];
  // 2. Crie um estado para controlar se o menu está aberto
  const [isOpen, setIsOpen] = useState(false);

  // 3. Crie uma função para lidar com o clique em um item
  const handleSelect = (path) => {
    logger.info(`Sessão navegigou via Menu para: ${path}`, { path });
    navigate(path); // Navega para a página desejada
    setIsOpen(false); // Fecha o menu
  };

  return (
    // 4. Controle o Popover com o estado
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <button
          className="rounded-full p-2 text-gray-600 hover:bg-gray-100 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-200"
          aria-label="Abrir menu principal"
        >
          <Menu className="h-6 w-6" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-56 bg-white dark:bg-gray-900" align="end">
        <div className="flex flex-col space-y-1">
          {itens.map((item) => (
            <button
              key={item.path}
              onClick={() => handleSelect(item.path)} // 5. Chame a função handleSelect
              className="flex w-full items-center gap-3 rounded-md p-2 text-left text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800"
            >
              <item.icon className="h-5 w-5 text-gray-500 dark:text-gray-400" />
              <span>{item.label}</span>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}

